import { render, staticRenderFns } from "./OcorrenciaItem.vue?vue&type=template&id=1934db0d"
import script from "./OcorrenciaItem.vue?vue&type=script&lang=js"
export * from "./OcorrenciaItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports